import React from "react";
import { pa1, pa2, pa3 } from "../../images/image";
export const Patrocinadores = () => {
  return (
    <div className="patrocinadores-ct">
      <div className="pa-img">
        <img src={pa1} alt="Nike" />
        <img src={pa2} alt="Qatar" />
        <img src={pa3} alt="GOAT" />
      </div>
    </div>
  );
};
